'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentError = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FramedComponent = require('../../hoc/FramedComponent');

var _FramedComponent2 = _interopRequireDefault(_FramedComponent);

var _InjectedIframeHTML = require('./InjectedIframeHTML');

var _InjectedIframeHTML2 = _interopRequireDefault(_InjectedIframeHTML);

var _DynamicForm = require('./DynamicForm');

var _DynamicForm2 = _interopRequireDefault(_DynamicForm);

var _PaymentResult = require('./PaymentResult');

var _PaymentResult2 = _interopRequireDefault(_PaymentResult);

var _NewTab = require('./NewTab');

var _NewTab2 = _interopRequireDefault(_NewTab);

var _flatten = require('lodash/flatten');

var _flatten2 = _interopRequireDefault(_flatten);

var _Translate = require('../../../../components/Translate');

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormWithIframe = (0, _FramedComponent2.default)(_DynamicForm2.default);

var PaymentError = exports.PaymentError = function PaymentError(_ref) {
  var data = _ref.data,
      onClose = _ref.onClose;

  var errorKeys = [];
  if (data.error) {
    errorKeys = [data.error.keys];
  } else {
    errorKeys = (0, _flatten2.default)(data.errors.map(function (error) {
      return error.keys;
    }));
  }

  return _react2.default.createElement(
    _PaymentResult2.default,
    { success: false, onClose: onClose },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_Translate2.default, {
        defaultMessage: 'message.payment.error',
        id: 'message.payment.error'
      })
    ),
    _react2.default.createElement(
      'div',
      null,
      errorKeys.map(function (key) {
        return _react2.default.createElement(
          'div',
          { key: key },
          _react2.default.createElement(_Translate2.default, {
            defaultMessage: 'paymentiq.' + key,
            id: 'paymentiq.' + key
          })
        );
      })
    )
  );
};

var PaymentSuccess = function PaymentSuccess(_ref2) {
  var onClose = _ref2.onClose;

  return _react2.default.createElement(
    _PaymentResult2.default,
    { success: true, onClose: onClose },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_Translate2.default, {
        defaultMessage: 'message.payment.success',
        id: 'message.payment.success'
      })
    )
  );
};

var PaymentForm = function (_Component) {
  _inherits(PaymentForm, _Component);

  function PaymentForm() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, PaymentForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = PaymentForm.__proto__ || Object.getPrototypeOf(PaymentForm)).call.apply(_ref3, [this].concat(args))), _this), _this.onMessage = function (message) {
      var operatingSystem = _this.props.operatingSystem;

      var data = JSON.parse(message.data);

      if (data.method === 'OPEN_APP') {
        if (operatingSystem === 'iOS') {
          location.assign(data.appURL + encodeURIComponent(window.location.href + '#'));
        } else {
          location.assign(data.appURL);
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaymentForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', this.onMessage);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.onMessage);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          onClose = _props.onClose,
          onSuccess = _props.onSuccess,
          redirect = _props.redirect,
          details = _props.details,
          iframeProps = _props.iframeProps;


      if (!data.success) {
        return _react2.default.createElement(PaymentError, { data: data, onClose: onClose });
      }

      if (data.redirectOutput == null) {
        if (onSuccess) {
          onSuccess({
            amount: data.amount,
            currency: data.currency,
            tx: Number(data.transactionId)
          });
          return null;
        }

        return _react2.default.createElement(PaymentSuccess, { data: data, onClose: onClose });
      }

      var frameId = 'iframedeposit' + Math.floor(Math.random() * 10000);
      var frameProps = {
        id: frameId,
        name: frameId,
        width: data.redirectOutput.width,
        height: data.redirectOutput.height,
        frameBorder: 0
      };

      if (details && details.newTab) {
        return _react2.default.createElement(_NewTab2.default, { url: data.redirectOutput.url });
      } else if (data.redirectOutput.container == 'iframe' && data.redirectOutput.method == 'POST' && data.redirectOutput.html == null) {
        return _react2.default.createElement(FormWithIframe, _extends({
          frameProps: frameProps,
          target: redirect ? '_top' : frameId
        }, data.redirectOutput));
      } else if (data.redirectOutput.container == 'iframe' && data.redirectOutput.method == 'POST' && data.redirectOutput.html != null) {
        return _react2.default.createElement(_InjectedIframeHTML2.default, { data: data, iframeProps: iframeProps });
      } else if (data.redirectOutput.container == 'iframe' && data.redirectOutput.method == 'GET' && data.redirectOutput.html != null) {
        return _react2.default.createElement(_InjectedIframeHTML2.default, { data: data, iframeProps: iframeProps });
      } else if (data.redirectOutput.container == 'iframe' && data.redirectOutput.method == 'GET' && redirect) {
        window.location.replace(data.redirectOutput.url);
        return null;
      } else if (data.redirectOutput.container == 'iframe' && data.redirectOutput.method == 'GET') {
        return _react2.default.createElement('iframe', _extends({
          src: data.redirectOutput.url,
          width: data.redirectOutput.width,
          height: data.redirectOutput.height,
          frameBorder: '0'
        }, iframeProps));
      } else if (data.redirectOutput.container == 'window' && data.redirectOutput.method == 'POST') {
        return _react2.default.createElement(_DynamicForm2.default, data.redirectOutput);
      } else if (data.redirectOutput.container == 'window' && data.redirectOutput.method == 'GET') {
        window.location.href = data.redirectOutput.url;
        return null;
      }

      return null;
    }
  }]);

  return PaymentForm;
}(_react.Component);

exports.default = PaymentForm;